import React, { useState, useEffect } from 'react';
import { AreaMap } from '@ant-design/maps';
import geoJson from '../../json/portugal.json';
import { Card } from 'antd';

const DensityHeatmap = (props) => {
  const [data, setData] = useState({ type: 'FeatureCollection', features: [] });

  useEffect(() => {
    asyncFetch();
  }, []);

  const asyncFetch = () => {
    fetch('data/correlation/correlation_values.json')
      .then((response) => response.json())
      .then((json) => mapData(json[props.label.toLowerCase()]))
      .catch((error) => {
        console.log('fetch data failed', error);
      });
  };

  const mapData = (jsonData) => {
    for (const feature of geoJson.features) {
      feature.properties.density = parseFloat((jsonData[feature.properties.name]*100).toFixed(2));
    }

    setData(geoJson);
  };

  const config = {
    map: {
      type: 'mapbox',
      style: 'blank',
      zoom: 5,
      pitch: 0,
    },
    source: {
      data: data,
      parser: {
        type: 'geojson',
      },
    },
    autoFit: true,
    color: {
      field: 'density',
      value: ['#fee5d9', '#fcae91', '#fb6a4a', '#de2d26', '#a50f15'],
      scale: {
        type: 'quantile',
      },
    },
    style: {
      opacity: 1,
      stroke: '#fff',
      lineWidth: 0.6,
      lineOpacity: 1,
    },
    state: {
      active: true,
    },
    label: {
      visible: true,
      field: 'name',
      style: {
        fill: '#000',
        opacity: 0.8,
        fontSize: 10,
        stroke: '#fff',
        strokeWidth: 1.5,
        textAllowOverlap: false,
        padding: [8, 8],
      },
    },
    tooltip: {
      items: [
        { field: 'name', alias: 'Nome' },
        { field: 'density', alias: 'Densidade (%)' },
      ],
    },
    zoom: {
      position: 'bottomright',
    },
    legend: {
      position: 'bottomleft',
    },
  };

  return (
    <div style={{ width: '100%', height: '20em', margin: 'auto' }}>
      <AreaMap {...config} />{' '}
    </div>
  );
};

export default DensityHeatmap;
